import { Controller } from "@hotwired/stimulus"

// Triggers window.print(). Replaces inline `onclick="window.print()"` so the
// view stays free of inline JS (project rule, also CSP-friendly).
export default class extends Controller {
  print(event) {
    if (event) event.preventDefault()
    window.print()
  }
}
